import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';
import { isNil, remove, reverse } from 'lodash';
import {  TreeviewItem, TreeviewConfig, TreeviewHelper, TreeviewComponent,
  TreeviewEventParser, OrderDownlineTreeviewEventParser, DownlineTreeviewItem } from 'ngx-treeview1';
@Component({
  selector: 'app-acc-account',
  templateUrl: './acc-account.component.html',
  styleUrls: ['./acc-account.component.css']
})
export class AccAccountComponent implements OnInit {
  // items: any;
  config: TreeviewConfig = {
    hasAllCheckBox: false,
    hasFilter: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 500,
    hasDivider: false
  };
  simpleItems = {
    text: 'parent-1',
    value: 'p1',
    children: [
      {
        text: 'child-1',
        value: 'c1'
      }, {
        text: 'child-2',
        value: 'c2',
        children: [
          {
            text: 'child-1-2',
            value: 'c12'
          },
          {
            text: 'child-1-2',
            value: 'c12',
            disabled: true,
            collapsed: true,
            checked: true,
            children: [
              {
                text: 'child-1-2',
                value: 'c12'
              },
              {
                text: 'child-1-2',
                value: 'c12'
              }
            ]
          }
        ]
      },
    ]
  };

  simpleItems2 = {
    text: 'parent-2',
    value: 'p2',
    collapsed: true,
    children: [
      {
        text: 'child-1',
        value: 'c1'
      }, {
        text: 'child-2',
        value: 'c2',
        children: [
          {
            text: 'child-1-2',
            value: 'c12'
          },
          {
            text: 'child-1-2',
            value: 'c12',
            disabled: true,
            collapsed: true,
            checked: true,
            children: [
              {
                text: 'child-1-2',
                value: 'c12'
              },
              {
                text: 'child-1-2',
                value: 'c12'
              }
            ]
          }
        ]
      },
    ]
  };
  AccountModel = {
    BookID: 0,
    AccID: 0,
    BookName: '',
    SysCode: '',
    ChkIsGroup: false,
    IsGroup: 'N',
    TransDetID: 0,
    AccountGroupID: 0,
    AccountGroupTypeID: 0,
    Debit: false,
    Credit: false,
    IsActive: false,
    IsLinkPLBalance:false,
   
    AccName:"",
    AccCode:"",
    GroupAccName:"",
    GroupAccCode:"",
    GroupAccID:0,
    GroupIsGroup:"N",
    ChkGroupIsGroup: false,
    Amount:0,
    ParentID:0

};
AccountList:any;


  constructor(private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  ngOnInit() {
    // this.items = this.getItems([this.simpleItems, this.simpleItems2]);
    this.GetAccountGroup();
    this.GetAllAccount();
   


}
onFilterChange(item){
alert(JSON.stringify(item));
}
// onSelectedChange(item){
//   alert(item);
// }
items: TreeviewItem[];
rows: string[];
onSelectedChange(downlineItems: DownlineTreeviewItem[]): void {
  this.rows = [];
  
  downlineItems.forEach(downlineItem => {
    const item = downlineItem.item;
   
    // const value = item.value;
    // const texts = [item.text];
    // let parent = downlineItem.parent;
    // while (!isNil(parent)) {
    //   texts.push(parent.item.text);
    //   parent = parent.parent;
    // }
    // const reverseTexts = reverse(texts);
    // const row = `${reverseTexts.join(' -> ')} : ${value}`;
    // this.rows.push(row);
  });
}
selectNodeLabel(node){
  alert(node.IsLinkPLBalance);
   this.AccountModel.AccountGroupID = 0;

            if (node.IsGroup.trim() == 'Y') {
                 this.AccountModel.IsActive = node.IsActive;
                 this.AccountModel.GroupAccName = node.AccName;
                 this.AccountModel.SysCode = node.SysCode;
                 this.AccountModel.GroupAccCode = node.AccCode;
                 this.AccountModel.GroupAccID = node.AccID;
                 this.AccountModel.GroupIsGroup = node.IsGroup.trim();

                 this.AccountModel.TransDetID = node.TransDetID;
                 this.AccountModel.AccountGroupID = node.AccountGroupID;
                 this.AccountModel.IsLinkPLBalance = node.IsLinkPLBalance;

                 this.AccountModel.AccName = '';
                 this.AccountModel.AccCode = '';
                 this.AccountModel.AccID = 0;
                 this.AccountModel.IsGroup = 'N';
                 this.AccountModel.Amount = 0;
                 this.AccountModel.Debit = false;
                 this.AccountModel.Credit = false;

            } else {
                 this.AccountModel.GroupAccName = node.GroupAccName;
                 this.AccountModel.IsActive = node.IsActive;
                 this.AccountModel.SysCode = node.SysCode;
                 this.AccountModel.GroupAccCode = node.GroupAccCode;
                 this.AccountModel.GroupAccID = node.GroupAccID;
                 this.AccountModel.GroupIsGroup = node.GroupIsGroup.trim();
                 this.AccountModel.IsLinkPLBalance = node.IsLinkPLBalance;
                 this.AccountModel.AccName = node.AccName;
                 this.AccountModel.AccCode = node.AccCode;
                 this.AccountModel.AccountGroupID = node.AccountGroupID;
                // this.GetAccountGroupType();
                // this.AccountModel.AccountGroupTypeID = node.AccountGroupTypeID;
                 this.AccountModel.AccID = node.AccID;
                 this.AccountModel.TransDetID = node.TransDetID;
                 this.AccountModel.IsGroup = node.IsGroup.trim();
                 this.AccountModel.Amount = node.DebitAmt == 0 ? node.CreditAmt : node.DebitAmt;
                //  this.AccountModel.ChkGroupIsGroup=this.AccountModel.GroupIsGroup=="Y"?true:false;   
                 this.AccountModel.Debit = node.DebitAmt == 0 ? false : true;
                 this.AccountModel.Credit = node.CreditAmt == 0 ? false : true;


            }

            if (node.collapsed)
                node.collapsed = false;
            else
                node.collapsed = true;


            //var root = $scope;
            //var currentScope = angular.element($event.target).scope();

            //console.log('selected Node details: ', currentScope.node);
            //alert(currentScope.node.AccID);
            //while (currentScope.$id !== root.$id) {
            //    console.log(currentScope.node);
            //    currentScope = currentScope.$parent;
            //}
 
};
getItems(parentChildObj) {
  let itemsArray = [];
  parentChildObj.forEach(set => {
    itemsArray.push(new TreeviewItem(set))
  });
  return itemsArray;
}


GetAllAccount() {
  this.spinnerService.show();
  this.accService.GetAllAccount().subscribe( (response)=> {
      this.AccountList = response.AccountList;
      this.items = this.getItems(response.AccList);
      this.spinnerService.hide();
  });
};


Submitted = false;
   Clear  () {
  this.AccountModel.IsGroup = 'N';  
  this.AccountModel.AccountGroupID = 0;
  this.AccountModel.AccID = 0;    
  this.AccountModel.AccCode = '';
  this.AccountModel.Amount = 0;
  this.AccountModel.Debit = true;
  this.AccountModel.Credit = false;
  this.AccountModel.IsActive = false;
  this.AccountModel.AccName = '';
  this.AccountModel.IsLinkPLBalance = false;
  this.Submitted = false;
  this.AccountModel.TransDetID= 0;
};
AccountGroupList:any;
GetAccountGroup  () {
  this.lookupService.GetLookupsList('AccGroup', '').subscribe( (data)=> {
      this.AccountGroupList = data.LookupItems;
      
      });
}

GetAccountCredit  () {
 
 
      this.AccountModel.Debit = false;
      this.AccountModel.Credit = true;
  
}
GetAccountDebit  () {
  this.AccountModel.Debit = true;
  this.AccountModel.Credit = false;
 
}
Edit(node){
 
      this.AccountModel.AccName = node.AccName;
      this.AccountModel.IsLinkPLBalance = node.IsLinkPLBalance;
      this.AccountModel.IsGroup = node.IsGroup;
      this.AccountModel.ChkIsGroup=this.AccountModel.IsGroup=="Y"?true:false; 
      this.AccountModel.AccCode = node.AccCode;
      this.AccountModel.AccID = node.AccID;
      this.AccountModel.IsActive = node.IsActive;
      this.AccountModel.GroupAccName = node.GroupAccName;
      this.AccountModel.SysCode = node.SysCode;
      this.AccountModel.GroupAccCode = node.GroupAccCode;
      this.AccountModel.GroupAccID = node.GroupAccID;
      this.AccountModel.GroupIsGroup = node.GroupIsGroup;  
      this.AccountModel.ChkGroupIsGroup=this.AccountModel.GroupIsGroup=="Y"?true:false;   
      this.AccountModel.TransDetID = node.TransDetID;
      this.AccountModel.AccountGroupID = node.AccountGroupID;
      this.AccountModel.Amount = node.DebitAmt == 0  ? node.CreditAmt : node.DebitAmt;
      if(node.CreditAmt){
        this.AccountModel.Credit=true;
        this.AccountModel.Debit=false;
      }
      else{
        this.AccountModel.Debit=true;
        this.AccountModel.Credit=false;
      }
   
}


ValidationAccount  () {
  return this.AccountModel.AccName=='';
}
ImportAccount  () {
  this.Submitted = true;  
 
  this.spinnerService.show()
      this.accService.ImportAccount().subscribe( (response)=> {
          this.spinnerService.hide();             
              this.GetAllAccount();         
        this.globalHelper.CheckActionStatus(response)

  });

}
ParentAcc = '';
SaveAccount  () {
  this.Submitted = true; 
 
  if (!this.ValidationAccount()) {
    this.AccountModel.IsGroup=this.AccountModel.ChkIsGroup==true?'Y':'N'
    this.AccountModel.GroupIsGroup=this.AccountModel.ChkGroupIsGroup==true?'Y':'N'
  this.spinnerService.show()
      this.accService.SaveAccount(JSON.stringify(this.AccountModel)).subscribe( (response)=> {
          if (response.ActinSatus) {
          this.ParentAcc = '';
         if(this.AccountModel.AccID==0){
          this.Clear();
         }
          this.AccountModel.GroupAccCode = "";         
             this.spinnerService.hide();             
              this.GetAllAccount();         
           this.GetAccountGroup();
      }
      this.globalHelper.CheckActionStatus(response)

  });
}
}

DeleteAccount  () {
  var r = confirm("Are you sure you want to delete account ");
  if (r == true) {
      this.Submitted = true;
     
      this.spinnerService.show()
      this.accService.DeleteAccount(JSON.stringify(this.AccountModel)).subscribe( (response)=> {
          this.ParentAcc = '';
          this.Clear();
          this.AccountModel.GroupAccCode = "";
         
             this.spinnerService.hide()
             
              this.GetAllAccount();
      


          this.globalHelper.CheckActionStatus(response)

      });
  }
}



}
